import { render, staticRenderFns } from "./ManagerTasks.vue?vue&type=template&id=6bbbcd01&scoped=true"
import script from "./ManagerTasks.vue?vue&type=script&lang=js"
export * from "./ManagerTasks.vue?vue&type=script&lang=js"
import style0 from "./ManagerTasks.vue?vue&type=style&index=0&id=6bbbcd01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbbcd01",
  null
  
)

export default component.exports